import React from 'react'
import { Typography, Box } from '@mui/material'
import SFDialog from '../../../lib/southfork/components/sf-dialog/sf-dialog'

interface CancelProposalDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  proposalFund: string
  bidDeadline: string
  issuerCount: number
  isLoading?: boolean
}

export const CancelProposalDialog: React.FC<CancelProposalDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  proposalFund,
  bidDeadline,
  issuerCount,
  isLoading = false,
}) => {
  const formattedDeadline = new Date(bidDeadline).toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  })

  return (
    <SFDialog
      title="Cancel Proposal"
      isOpen={isOpen}
      onCancel={onClose}
      onOk={onConfirm}
      okButtonText={isLoading ? 'Cancelling...' : 'Cancel Proposal'}
      okButtonColor="error"
      cancelButtonText="Keep Proposal"
      maxWidth="sm"
      isOkDisabled={isLoading}
    >
      <Box sx={{ py: 2 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          You are about to cancel Proposal [{proposalFund} - {formattedDeadline}
          ].
        </Typography>

        <Box component="ul" sx={{ pl: 2, mb: 2 }}>
          <Typography component="li" variant="body2" sx={{ mb: 1 }}>
            All {issuerCount} participating GIC Issuers will be notified that
            the proposal has been withdrawn.
          </Typography>
          <Typography component="li" variant="body2">
            No bids will be awarded and this action cannot be undone.
          </Typography>
        </Box>

        <Typography variant="body1">
          Are you sure you wish to cancel the proposal?
        </Typography>
      </Box>
    </SFDialog>
  )
}
